import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-reading',
  template: ``,
  styleUrls: []
})
export class FormReadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
